module.exports = __webpack_public_path__ + "img/产品详情1智能选址-banner-3.0a98a74d.png";